import { useCallback, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import { Box, CssBaseline, Typography } from '@mui/material'
import { Layout } from './Layout'
import { PrescriptionDetailPage } from './detail/PrescriptionDetailPage'
import { useSyncOwnPapers } from './remoteInput/useRemoteInput'
import { colorTokens, latestTheme } from '../../../shared/styles/theme'

/**
 * まもる latest のエントリポイント(apps/medilab/App.tsx から use_legacy_ui=false で分岐)。
 *
 * 第一版に載せるのは 一覧 / 画像 / 項目 / 報告 / 値の修正 / レセコンに送信 + サポートコード の
 * 6 つだけ(ADR-0030 で 4 つに絞り、ADR-0032 で修正・ADR-0033 で送信を足した)。
 * **面は「詳細」1 つ**で、一覧は Sidebar に置く(格納可能)。詳細は画像左・項目右の常時突合
 * (ADR-0010)。
 */
const MediLabLatestApp = () => {
  // QuickSync の知らせを押した先は `/?event=<読み取りの id>`(ADR-0075)。初期値にだけ使い、
  // 選び直しても URL には書き戻さない(route は「詳細」1 つのまま)
  const [searchParams] = useSearchParams()
  const [selectedId, setSelectedId] = useState<string | null>(() =>
    searchParams.get('event')
  )
  const clearSelection = useCallback(() => setSelectedId(null), [])
  useSyncOwnPapers()

  return (
    <ThemeProvider theme={latestTheme}>
      <CssBaseline />
      <Layout selectedId={selectedId} onSelect={setSelectedId}>
        {selectedId ? (
          <PrescriptionDetailPage
            ocrRequestEventId={selectedId}
            onGone={clearSelection}
          />
        ) : (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {/* empty-states.md 型1「まだ何も選ばれていない」= 1 文だけ置く */}
            <Typography sx={{ fontSize: 14, color: colorTokens.fg.faint }}>
              処方箋を選んでください
            </Typography>
          </Box>
        )}
      </Layout>
    </ThemeProvider>
  )
}

export default MediLabLatestApp
